module.exports = __webpack_public_path__ + "img/Weapon_193.be8b0c51.png";